import { CardContent, Separator } from '@ais-ui/ui-core';
import { BaseStationTargetInfo } from '@ais-ui/websockets';
import React from 'react';
import { useSettings } from '../../Settings/SettingsProvider';

interface BaseStationInfoTooltipProps {
  baseStationInfo: BaseStationTargetInfo;
}

interface BaseStationInfoTooltipItemProps {
  label: string;
  value: string;
}

const BaseStationInfoTooltipItem = ({
  label,
  value,
}: BaseStationInfoTooltipItemProps) => {
  return (
    <div className="grid grid-cols-[1fr_auto] gap-2 max-w-[12rem]">
      <p className="text-xs font-medium flex-none text-left max-w-[6rem]">
        {label}
      </p>
      <p className="text-xs text-muted-foreground flex-grow text-right">
        {value ? value : '-'}
      </p>
    </div>
  );
};

export const BaseStationInfoTooltip = ({
  baseStationInfo,
}: BaseStationInfoTooltipProps) => {
  const { settings } = useSettings();
  const ribbonSettings = settings['ribbonPlugin.settings'];

  // Check if any of the settings are enabled and corresponding data exists
  const hasVisibleItems =
    (ribbonSettings?.show_basestation_country && baseStationInfo.country) ||
    (ribbonSettings?.show_basestation_latitude && baseStationInfo.latitude) ||
    (ribbonSettings?.show_basestation_longitude && baseStationInfo.longitude) ||
    (ribbonSettings?.show_basestation_mmsi && baseStationInfo.mmsi) ||
    (ribbonSettings?.show_basestation_vdl_load && baseStationInfo.vdlLoad);

  // Return null if no items will be shown
  if (!hasVisibleItems) {
    return null;
  }

  return (
    <CardContent className="pt-0 pb-2 -mt-1 space-y-2 px-3">
      <Separator className="-ml-1"></Separator>
      <div className="grid grid-cols-[auto_auto] gap-x-4 gap-y-1">
        {ribbonSettings?.show_basestation_country &&
          baseStationInfo.country && (
            <BaseStationInfoTooltipItem
              key="country"
              label="Country"
              value={baseStationInfo.country}
            ></BaseStationInfoTooltipItem>
          )}
        {ribbonSettings?.show_basestation_latitude &&
          baseStationInfo.latitude && (
            <BaseStationInfoTooltipItem
              key="latitude"
              label="Latitude"
              value={baseStationInfo.latitude.toString()}
            ></BaseStationInfoTooltipItem>
          )}
        {ribbonSettings?.show_basestation_longitude &&
          baseStationInfo.longitude && (
            <BaseStationInfoTooltipItem
              key="longitude"
              label="Longitude"
              value={baseStationInfo.longitude.toString()}
            ></BaseStationInfoTooltipItem>
          )}
        {ribbonSettings?.show_basestation_mmsi && baseStationInfo.mmsi && (
          <BaseStationInfoTooltipItem
            key="mmsi"
            label="MMSI"
            value={baseStationInfo.mmsi}
          ></BaseStationInfoTooltipItem>
        )}
        {ribbonSettings?.show_basestation_vdl_load &&
          baseStationInfo.vdlLoad && (
            <BaseStationInfoTooltipItem
              key="vdlLoad"
              label="VDL Load"
              value={baseStationInfo.vdlLoad}
            ></BaseStationInfoTooltipItem>
          )}
      </div>
    </CardContent>
  );
};
